const LEAD_SUBMISSION_KEY = "openai_ads_lead_submission"

const canMeasure = () =>
  typeof window !== "undefined" &&
  Boolean(process.env.GATSBY_OPENAI_ADS_PIXEL_ID) &&
  typeof window.oaiq === "function"

export const measurePageViewed = location => {
  try {
    if (!canMeasure()) return

    const pathname = location?.pathname || window.location.pathname

    window.oaiq("measure", "page_viewed", {
      type: "contents",
      contents: [
        {
          id: pathname,
          name: document.title || pathname,
          content_type: "page",
        },
      ],
    })
  } catch (_) {
    // Conversion reporting must never interrupt navigation.
  }
}

export const markLeadSubmission = () => {
  try {
    window.sessionStorage.setItem(LEAD_SUBMISSION_KEY, "pending")
  } catch (_) {
    // The form submission should continue if storage is unavailable.
  }
}

export const measureConfirmedLead = () => {
  try {
    if (typeof window === "undefined") return

    const isPending =
      window.sessionStorage.getItem(LEAD_SUBMISSION_KEY) === "pending"

    if (!isPending) return

    window.sessionStorage.removeItem(LEAD_SUBMISSION_KEY)

    if (!canMeasure()) return

    window.oaiq("measure", "lead_created", {
      type: "customer_action",
    })
  } catch (_) {
    // Conversion reporting must never interrupt the thank-you page.
  }
}
